// extracted by css-extract-rspack-plugin
export default {"root":"root--A0WoHQPYmI0It0VN"};